/* eslint-disable react/require-default-props, prettier/prettier */
import * as React from 'react';
import PropTypes from 'prop-types';
import { cn } from '../../lib/utils';

const ScrollArea = React.forwardRef(function ScrollArea({ className, children, ...props }, ref) {
  return (
    <div
      ref={ref}
      className={cn('relative h-full overflow-y-auto overflow-x-hidden', className)}
      {...props}
    >
      {children}
    </div>
  );
});

ScrollArea.displayName = 'ScrollArea';

ScrollArea.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const ScrollBar = React.forwardRef(function ScrollBar(
  { className, orientation = 'vertical', ...props },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cn(
        'flex touch-none select-none transition-colors',
        orientation === 'vertical' && 'h-full w-2.5 border-l border-l-transparent p-[1px]',
        orientation === 'horizontal' && 'h-2.5 flex-col border-t border-t-transparent p-[1px]',
        className,
      )}
      {...props}
    >
      <div className="relative flex-1 rounded-full bg-border" />
    </div>
  );
});

ScrollBar.displayName = 'ScrollBar';

ScrollBar.propTypes = {
  className: PropTypes.string,
  orientation: PropTypes.oneOf(['vertical', 'horizontal']),
};

export { ScrollArea, ScrollBar };
